<ng-container *ngIf="articleDetails$ | async as articleDetails">
  <div class="d-flex flex-column gap-3 mt-3 pt-3">
    <div
      *ngIf="
        articleDetails?.co2Factor && articleDetails?.co2FactorMethod && articleDetails?.co2Factor !== '0';
        else noCO2ValueTemplate
      "
    >
      <i nz-icon nzType="co2" nzTheme="fill" class="mr-2"></i>
      <span
        >{{
          'catalog.co2Factor_hint'
            | cxTranslate: { value: articleDetails.co2Factor | cxNumeric: '1.3', unit: articleDetails.co2FactorUnit | unit: 1 }
        }}
        <cx-generic-link [routerUrl]="{ cxRoute: 'carbonFootprintLevels' } | cxUrl">{{
          'catalog.co2FactorMethod_hint' | cxTranslate: { method: articleDetails.co2FactorMethod }
        }}</cx-generic-link></span
      >
    </div>
    <ng-template #noCO2ValueTemplate>
      <div *pyPrincipalConfiguration="'enableDisplayCO2'">
        <i nz-icon nzType="co2" nzTheme="fill" class="mr-2"></i>
        <span>{{ 'catalog.co2FactorMissing_hint' | cxTranslate }}</span>
      </div>
    </ng-template>
    <div *ngIf="articleDetails?.vendorMaterialNumber">
      <i nz-icon nzType="factory" nzTheme="outline" class="mr-2"></i>
      <span>{{ 'catalog.vendorMaterialNumber_hint' | cxTranslate: { articleNumber: articleDetails.vendorMaterialNumber } }}</span>
    </div>
    <div *ngIf="articleDetails?.eanCode">
      <i nz-icon nzType="barcode-o" class="mr-2"></i>
      <span>{{ 'catalog.eanCode_hint' | cxTranslate: { code: articleDetails.eanCode } }}</span>
    </div>
    <div *ngIf="articleDetails?.unspsc">
      <i nz-icon nzType="undp" nzTheme="fill" class="mr-2"></i>
      <span>{{ 'catalog.unspsc_hint' | cxTranslate: { code: articleDetails.unspsc } }}</span>
    </div>
    <div class="article-code" *ngIf="articleDetails?.oldArticleNumber">
      {{ 'article.oldArticleNumber_hint' | cxTranslate: { articleNumber: articleDetails.oldArticleNumber } }}
    </div>
  </div>
</ng-container>
